import { ChangeDetectorRef, Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { FormHelper } from '../util/formHelper';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
  selector: 'app-create-operator',
  templateUrl: './create-operator.component.html',
  styleUrls: ['./create-operator.component.css']
})
export class CreateOperatorComponent implements OnInit {

  @ViewChild('adduserloader', { static: true }) loader;

  addUserForm = new FormGroup({
    name: new FormControl(''),
    description: new FormControl(''),
    userEmail: new FormControl(''),
    enableSeeDevices: new FormControl(''),
    enableActionateDevices: new FormControl(''),
    enableSeeAccessLog: new FormControl(''),
    enableUserEdit: new FormControl(''),
    enableGroupEdit: new FormControl(''),
    enableEditAutomations: new FormControl(''),
    enableSeeOperationsLog: new FormControl(''),
  });


  username: string = "";
  description: string = "";
  userEmail: string = "";

  enableSeeDevicesBool: boolean;
  enableActionateDevicesBool: boolean;
  enableSeeAccessLogBool: boolean;
  enableUserEditBool: boolean;
  enableGroupEditBool: boolean;
  enableEditAutomationsBool: boolean;
  enableSeeOperationsLogBool: boolean;



  userCreated: boolean = false;

  usernameError: boolean = false;
  emailError: boolean = false;
  missingCriteriaError: boolean = false;




  constructor(
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
  }

  createOperator() {
    this.usernameError = false;
    this.emailError = false;
    this.missingCriteriaError = false;

    this.userCreated = true;

    if (this.username == "") {
      this.usernameError = true;
      return;

    }

    if (!FormHelper.isValidEmail(this.userEmail)) {
      this.emailError = true;
      return;

    }

    if (!this.enableSeeDevicesBool) {
      this.missingCriteriaError = true;
      return;

    }

    if (!this.enableActionateDevicesBool) {
      this.missingCriteriaError = true;
      return;

    }

    if (!this.enableSeeAccessLogBool) {
      this.missingCriteriaError = true;
      return;

    }

    if (!this.enableUserEditBool) {
      this.missingCriteriaError = true;
      return;

    }

    if (!this.enableGroupEditBool) {
      this.missingCriteriaError = true;
      return;

    }

    if (!this.enableEditAutomationsBool) {
      this.missingCriteriaError = true;
      return;

    }

    if (!this.enableSeeOperationsLogBool) {
      this.missingCriteriaError = true;
      return;

    }
    this.loader.showLoading();
    setTimeout(() => {
      this.loader.hideLoading();

      let snackBarRef = this.snackBar.open($localize`:@@addOperator_creation_successful:Operatore creato con successo`, $localize`:@@addOperator_toast_close:Chiudi`, {
        duration: 3000,
        panelClass: ['green-snackbar']
      });
    }, 3000);
  }
}
